import axios from "axios";
import axiosErrorInterceptor from "./axiosErrorInterceptor";
import axiosJwtInterceptor from "./axiosJwtInterceptor";
import axiosSuccessInterceptor from "./axiosSuccessInterceptor";

const http = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

// const resetToken = async () => {
//   const auth = store.getState().authentication.auth;
//   if (auth?.id_token) {
//     let currentTime = new Date().getTime();
//     const tokenData = parseJwt(auth.id_token);
//     // JWT exp is in seconds
//     if (tokenData.exp * 1000 < currentTime) {
//       await store.dispatch(postRefreshToken(auth.refresh_token));
//     }
//   }
// };

// axiosRetry(http, { onRetry: () => resetToken(), retries: 3 });

http.interceptors.request.use(axiosJwtInterceptor, (e) => Promise.reject(e));

http.interceptors.response.use(
  (response) => axiosSuccessInterceptor(response),
  (error) => axiosErrorInterceptor(error)
);

export const authHttp = axios.create({
  baseURL: `${process.env.REACT_APP_API_AUTH_BASE_URL}`,
  headers: {
    "Content-type": "application/json",
  },
});
authHttp.interceptors.request.use(axiosJwtInterceptor, (e) =>
  Promise.reject(e)
);

authHttp.interceptors.response.use(
  (response) => axiosSuccessInterceptor(response),
  (error) => axiosErrorInterceptor(error)
);

export default http;
